import { EpimsBaseEntityDto } from './epim-base.dto';
export class SubSubGroupDto extends EpimsBaseEntityDto {

    SubSubGroupId: string;
    SubSubGroupName: string;   
    SubSubGroupCode:string;
    SubGroupId: string;
    CategoryId: string;  
    SubSubGroupTypeId: string;
    SubSubGroupTypeCategoryId: string;
    SubscriptionUserId: string;
    SubscriberId: string;
    SiteId: string;
    ModifiedById: string;
    CreatedById: string;
    dateUpdated: Date;
    dateCreated: Date;
    Version: Number;
}